/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AtsAttribution } from './atsAttribution';
import type { DormantLinkView } from './dormantLinkView';
import type { JobAtsLinkResponseCapabilitiesSnapshot } from './jobAtsLinkResponseCapabilitiesSnapshot';
import type { JobAtsLinkResponseSyncDirection } from './jobAtsLinkResponseSyncDirection';

export interface JobAtsLinkResponse {
  linked: boolean;
  connection_id?: string | null;
  connector_name?: string | null;
  remote_job_url?: string | null;
  capabilities_snapshot?: JobAtsLinkResponseCapabilitiesSnapshot;
  sync_direction?: JobAtsLinkResponseSyncDirection;
  attribution?: AtsAttribution | null;
  dormant?: DormantLinkView | null;
  importing?: boolean;
}
